import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class CobbledRoadTileEntity3 extends TileEntity {
	public static readonly frameName = FrameName.COBBLED_ROAD_3;
}

export default CobbledRoadTileEntity3;
